import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Text,
  Icon,
  useColorModeValue,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  SimpleGrid,
  Alert,
  AlertIcon,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogBody,
  AlertDialogFooter,
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightElement,
  Stack,
  Select,
  Tabs,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Spinner,
  Box,
} from "@chakra-ui/react";

import React, { useMemo, useEffect, useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { useHistory } from "react-router-dom";
import AuthService from "services/auth.services.js";
import ApiService from "services/api.js";
import UtilService from "services/util.service.js";
// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";

// Assets
import {
  MdCheckCircle,
  MdCancel,
  MdUpdate,
  MdDelete,
  MdWarning,
  MdCreate,
} from "react-icons/md";
export default function BranchTable(props) {
  // custom variable

  const history = useHistory();

  let DateFrom = UtilService.dateFrom;
  const fromDate = new Date();
  fromDate.setDate(fromDate.getDate() - 1);

  let defaultDateTo = fromDate.toJSON().slice(0, 10);
  let DateTo = defaultDateTo;

  // Use state variable
  const [loading, setLoading] = useState(true);
  const [inputDateFromBackdate, setDateFromBackdate] = useState(DateFrom);
  const [inputDateToBackdate, setDateToBackdate] = useState(DateTo);
  const [inputDateFromBackdatePB1, setDateFromBackdatePB1] = useState(DateFrom);
  const [inputDateToBackdatePB1, setDateToBackdatePB1] = useState(DateTo);
  const [show, setShow] = React.useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isProcessingPB1, setIsProcessingPB1] = useState(false);
  const [processingComplete, setProcessingComplete] = useState(false);
  const [processingCompletePB1, setProcessingCompletePB1] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessagePB1, setErrorMessagePB1] = useState("");
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [maxDateTo, setMaxDateTo] = useState("");
  const [minDatePB1, setMinDatePB1] = useState("");
  const [maxDatePB1, setMaxDatePB1] = useState("");
  const [maxDateToPB1, setMaxDateToPB1] = useState("");
  const handleClick = () => setShow(!show);

  // ref variable
  const skipPageResetRef = React.useRef();
  const cancelRef = React.useRef();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleClose = () => {
    if (!isProcessing || processingComplete) {
      setShowAlert(false);
      setProcessingComplete(false);
      setErrorMessage("");
      onClose();
    }
  };

  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const handleClose2 = () => {
    if (!isProcessingPB1 || processingCompletePB1) {
      setShowAlert(false);
      setProcessingCompletePB1(false);
      setErrorMessagePB1("");
      onClose2();
    }
  };

  useEffect(() => {
    const formatDate = (date) => date.toISOString().split("T")[0];
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const fromDateRaw = new Date(inputDateFromBackdate);
    const fromDatePB1Raw = new Date(inputDateFromBackdatePB1);

    if (!Number.isNaN(fromDateRaw.getTime())) {
      // Keep Date From aligned to current selected Date To
      setMaxDate(formatDate(fromDateRaw));

      // Date To can be selected from Date From until min(Date From + 3 days, today)
      const maxAllowedToDate = new Date(fromDateRaw);
      maxAllowedToDate.setDate(maxAllowedToDate.getDate() + 3);
      const finalMaxToDate = maxAllowedToDate > today ? today : maxAllowedToDate;

      setMinDate(inputDateFromBackdate);
      setMaxDateTo(formatDate(finalMaxToDate));
    }

    if (!Number.isNaN(fromDatePB1Raw.getTime())) {
      // Keep Date From aligned to current selected Date To (PB1)
      setMaxDatePB1(formatDate(fromDatePB1Raw));

      // Date To can be selected from Date From until min(Date From + 3 days, today)
      const maxAllowedToDatePB1 = new Date(fromDatePB1Raw);
      maxAllowedToDatePB1.setDate(maxAllowedToDatePB1.getDate() + 3);
      const finalMaxToDatePB1 = maxAllowedToDatePB1 > today ? today : maxAllowedToDatePB1;

      setMinDatePB1(inputDateFromBackdatePB1);
      setMaxDateToPB1(formatDate(finalMaxToDatePB1));
    }

    setLoading(true);
  }, [inputDateFromBackdate, inputDateFromBackdatePB1]);

  // function backdate
  const processBackdate = async () => {
    // Validasi rentang maksimal 3 hari
    const dateFrom = new Date(inputDateFromBackdate);
    const dateTo = new Date(inputDateToBackdate);
    const diffTime = Math.abs(dateTo - dateFrom);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays > 3) {
      setErrorMessage("Rentang tanggal maksimal 3 hari. Silakan pilih rentang yang lebih kecil.");
      setShowAlert(true);
      return;
    }

    setIsProcessing(true);
    setShowAlert(true);
    setErrorMessage("");

    try {
      // Start the API call but don't wait for it
      ApiService.client.post(
        `/backdateProcess`, // The endpoint
        {
          email: ApiService.getEmail(),
          from_date: inputDateFromBackdate,
          to_date: inputDateToBackdate
        },
        await ApiService.options()
      )
        .catch(error => {
          // Only handle specific error cases
          if (error.response && error.response.status === 409) {
            setErrorMessage("Sistem sedang memproses permintaan lain. Mohon coba kembali beberapa saat lagi.");
            setIsProcessing(false);
            return;
          }
          // For other errors, we still consider the process as "started successfully"
          console.error("Error:", error);
        });

      // Immediately set processing as complete (don't wait for backend)
      setTimeout(() => {
        if (!errorMessage) {
          setIsProcessing(false);
          setProcessingComplete(true);
        }
      }, 1000);

    } catch (error) {
      console.error("Error:", error);
      setIsProcessing(false);
      setProcessingComplete(true);
    }
  };

  // function backdate pb1
  const processBackdatePB1 = async () => {
    // Validasi rentang maksimal 3 hari
    const dateFrom = new Date(inputDateFromBackdatePB1);
    const dateTo = new Date(inputDateToBackdatePB1);
    const diffTime = Math.abs(dateTo - dateFrom);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays > 3) {
      setErrorMessagePB1("Rentang tanggal maksimal 3 hari. Silakan pilih rentang yang lebih kecil.");
      setShowAlert(true);
      return;
    }

    setIsProcessingPB1(true);
    setShowAlert(true);
    setErrorMessagePB1("");

    try {
      // Start the API call but don't wait for it
      ApiService.client.post(
        `/backdatePb1Process`, // The endpoint
        {
          email: ApiService.getEmail(),
          from_date: inputDateFromBackdatePB1,
          to_date: inputDateToBackdatePB1
        },
        await ApiService.options()
      )
        .catch(error => {
          // Only handle specific error cases
          if (error.response && error.response.status === 409) {
            setErrorMessagePB1("Sistem sedang memproses permintaan lain. Mohon coba kembali beberapa saat lagi.");
            setIsProcessingPB1(false);
            return;
          }
          // For other errors, we still consider the process as "started successfully"
          console.error("Error:", error);
        });

      // Immediately set processing as complete (don't wait for backend)
      setTimeout(() => {
        if (!errorMessagePB1) {
          setIsProcessingPB1(false);
          setProcessingCompletePB1(true);
        }
      }, 1000);

    } catch (error) {
      console.error("Error:", error);
      setIsProcessingPB1(false);
      setProcessingCompletePB1(true);
    }
  };

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  return (
    <>
      <Tabs>
        <TabList>
          <Tab>RAW</Tab>
          <Tab>PB1</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <Card
              direction={{ base: "column", sm: "row" }}
              w="100%"
              px="0px"
              overflowX={{ sm: "scroll", md: "scroll", lg: "scroll" }}
            >
              <Flex px="25px" justify="space-between" mb="20px" align="center">
                <Text
                  color={textColor}
                  fontSize="22px"
                  fontWeight="700"
                  lineHeight="100%"
                >
                  Backdate Process Raw
                </Text>
                {/* <Menu /> */}
              </Flex>

              {/* Alert For Backdate Process */}
              <AlertDialog
                isOpen={isOpen}
                leastDestructiveRef={cancelRef}
                onClose={handleClose}
                closeOnOverlayClick={processingComplete || !isProcessing}
                closeOnEsc={processingComplete || !isProcessing}
              >
                <AlertDialogOverlay
                  bg="none"
                  backdropFilter="auto"
                  backdropInvert="100%"
                >
                  <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                      Process Backdate RAW
                    </AlertDialogHeader>

                    <AlertDialogBody>
                      {!showAlert ? (
                        "Apakah Anda yakin? Tindakan ini tidak dapat dibatalkan setelahnya."
                      ) : errorMessage ? (
                        <Alert status="error" variant="solid">
                          <AlertIcon />
                          {errorMessage}
                        </Alert>
                      ) : (
                        <Alert status="success" variant="solid">
                          <AlertIcon />
                          {isProcessing
                            ? "Proses sedang berjalan, harap tunggu..."
                            : "Proses sudah berjalan, silakan klik di mana saja untuk menutup dialog. Notifikasi akan dikirim via email saat proses selesai."}
                        </Alert>
                      )}
                    </AlertDialogBody>

                    <AlertDialogFooter>
                      {processingComplete || errorMessage ? (
                        <Button
                          colorScheme="facebook"
                          onClick={handleClose}
                          ml="auto"
                        >
                          Close
                        </Button>
                      ) : (
                        <>
                          <Button
                            ref={cancelRef}
                            onClick={handleClose}
                            isDisabled={isProcessing}
                          >
                            Cancel
                          </Button>
                          <Button
                            colorScheme="facebook"
                            onClick={() => processBackdate()}
                            ml={3}
                            isDisabled={isProcessing}
                            leftIcon={isProcessing ? <Spinner size="sm" /> : undefined}
                          >
                            {isProcessing ? "Processing..." : "Process"}
                          </Button>
                        </>
                      )}
                    </AlertDialogFooter>

                    {(processingComplete || errorMessage) && (
                      <Box position="absolute" top="0" right="0" bottom="0" left="0" onClick={handleClose} cursor="pointer" />
                    )}
                  </AlertDialogContent>
                </AlertDialogOverlay>
              </AlertDialog>
              <Flex px="25px" justify="space-between" mb="20px" align="center">
                <SimpleGrid
                  w="100%"
                  mb="20px"
                  columns={{ sm: 1, md: 2 }}
                  spacing={{ base: "20px", xl: "20px" }}
                >
                  <InputGroup>
                    <InputLeftAddon children="Date From" />
                    <Input
                      focusBorderColor="black"
                      placeholder="Select Date From"
                      borderRadius="16px"
                      type="date"
                      max={inputDateToBackdate || maxDate}
                      value={inputDateFromBackdate}
                      onChange={(e) => setDateFromBackdate(e.target.value)} />
                  </InputGroup>
                  <InputGroup>
                    <InputLeftAddon children="Date To" />
                    <Input
                      focusBorderColor="black"
                      placeholder="Select Date To"
                      borderRadius="16px"
                      type="date"
                      min={minDate}
                      max={maxDateTo}
                      value={inputDateToBackdate}
                      onChange={(e) => setDateToBackdate(e.target.value)} />
                  </InputGroup>
                </SimpleGrid>

              </Flex>
              <SimpleGrid
                w="100%"
                mb="20px"
                columns={{ sm: 2, md: 4 }}
                spacing={{ base: "20px", xl: "20px" }}
              >

                <Button right="0" ml={5} colorScheme="facebook" onClick={() => onOpen(true)}>
                  Process Backdate
                </Button>
              </SimpleGrid>

            </Card>
          </TabPanel>
          <TabPanel>
            <Card
              direction={{ base: "column", sm: "row" }}
              w="100%"
              px="0px"
              overflowX={{ sm: "scroll", md: "scroll", lg: "scroll" }}
            >
              <Flex px="25px" justify="space-between" mb="20px" align="center">
                <Text
                  color={textColor}
                  fontSize="22px"
                  fontWeight="700"
                  lineHeight="100%"
                >
                  Backdate Process PB1
                </Text>
                {/* <Menu /> */}
              </Flex>

              {/* Alert For Backdate Process */}
              <AlertDialog
                isOpen={isOpen2}
                leastDestructiveRef={cancelRef}
                onClose={handleClose2}
                closeOnOverlayClick={processingCompletePB1 || !isProcessingPB1}
                closeOnEsc={processingCompletePB1 || !isProcessingPB1}
              >
                <AlertDialogOverlay
                  bg="none"
                  backdropFilter="auto"
                  backdropInvert="100%"
                >
                  <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                      Process Backdate PB1
                    </AlertDialogHeader>

                    <AlertDialogBody>
                      {!showAlert ? (
                        "Are you sure? You can't undo this action afterwards."
                      ) : errorMessagePB1 ? (
                        <Alert status="error" variant="solid">
                          <AlertIcon />
                          {errorMessagePB1}
                        </Alert>
                      ) : (
                        <Alert status="success" variant="solid">
                          <AlertIcon />
                          {isProcessingPB1
                            ? "Proses sedang berjalan, harap tunggu..."
                            : "Proses sudah berjalan, silakan klik di mana saja untuk menutup dialog. Notifikasi akan dikirim via email saat proses selesai."}
                        </Alert>
                      )}
                    </AlertDialogBody>

                    <AlertDialogFooter>
                      {processingCompletePB1 || errorMessagePB1 ? (
                        <Button
                          colorScheme="facebook"
                          onClick={handleClose2}
                          ml="auto"
                        >
                          Close
                        </Button>
                      ) : (
                        <>
                          <Button
                            ref={cancelRef}
                            onClick={handleClose2}
                            isDisabled={isProcessingPB1}
                          >
                            Cancel
                          </Button>
                          <Button
                            colorScheme="facebook"
                            onClick={() => processBackdatePB1()}
                            ml={3}
                            isDisabled={isProcessingPB1}
                            leftIcon={isProcessingPB1 ? <Spinner size="sm" /> : undefined}
                          >
                            {isProcessingPB1 ? "Processing..." : "Process"}
                          </Button>
                        </>
                      )}
                    </AlertDialogFooter>

                    {(processingCompletePB1 || errorMessagePB1) && (
                      <Box position="absolute" top="0" right="0" bottom="0" left="0" onClick={handleClose2} cursor="pointer" />
                    )}
                  </AlertDialogContent>
                </AlertDialogOverlay>
              </AlertDialog>
              <Flex px="25px" justify="space-between" mb="20px" align="center">
                <SimpleGrid
                  w="100%"
                  mb="20px"
                  columns={{ sm: 1, md: 2 }}
                  spacing={{ base: "20px", xl: "20px" }}
                >
                  <InputGroup>
                    <InputLeftAddon children="Date From" />
                    <Input
                      focusBorderColor="black"
                      placeholder="Select Date From"
                      borderRadius="16px"
                      type="date"
                      max={inputDateToBackdatePB1 || maxDatePB1}
                      value={inputDateFromBackdatePB1}
                      onChange={(e) => setDateFromBackdatePB1(e.target.value)} />
                  </InputGroup>
                  <InputGroup>
                    <InputLeftAddon children="Date To" />
                    <Input
                      focusBorderColor="black"
                      placeholder="Select Date To"
                      borderRadius="16px"
                      type="date"
                      min={minDatePB1}
                      max={maxDateToPB1}
                      value={inputDateToBackdatePB1}
                      onChange={(e) => setDateToBackdatePB1(e.target.value)} />
                  </InputGroup>
                </SimpleGrid>

              </Flex>
              <SimpleGrid
                w="100%"
                mb="20px"
                columns={{ sm: 2, md: 4 }}
                spacing={{ base: "20px", xl: "20px" }}
              >

                <Button right="0" ml={5} colorScheme="facebook" onClick={() => onOpen2(true)}>
                  Process Backdate
                </Button>
              </SimpleGrid>

            </Card>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
}
